import React from 'react';

import './Card.scss';

const Card = ({ title, body, hidden=false }) => !hidden ? (
  <div className="card">
    {title && (
      <div className="card__title">
        {title}
      </div>
    )}
    <div className="card__body">
      {body}
    </div>
  </div>
) : null;

export default Card;
